/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AuthorizedSellerKeywordFilteringProtocolsAddKeywordsRequest,
  AuthorizedSellerKeywordFilteringProtocolsAddKeywordsResponse,
  AuthorizedSellerKeywordFilteringProtocolsDeleteKeywordRequest,
  AuthorizedSellerKeywordFilteringProtocolsGetKeywordsRequest,
  AuthorizedSellerKeywordFilteringProtocolsGetKeywordsResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class AuthorizedSellerKeywordFiltering<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags AuthorizedSellerKeywordFiltering
   * @name KeywordFilteringListCreate
   * @request POST:/authorized-seller/keyword-filtering/list
   */
  keywordFilteringListCreate = (
    data: AuthorizedSellerKeywordFilteringProtocolsGetKeywordsRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<AuthorizedSellerKeywordFilteringProtocolsGetKeywordsResponse, any>({
      path: `/authorized-seller/keyword-filtering/list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AuthorizedSellerKeywordFiltering
   * @name KeywordFilteringAddCreate
   * @request POST:/authorized-seller/keyword-filtering/add
   */
  keywordFilteringAddCreate = (
    data: AuthorizedSellerKeywordFilteringProtocolsAddKeywordsRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<AuthorizedSellerKeywordFilteringProtocolsAddKeywordsResponse, any>({
      path: `/authorized-seller/keyword-filtering/add`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AuthorizedSellerKeywordFiltering
   * @name KeywordFilteringDeleteCreate
   * @request POST:/authorized-seller/keyword-filtering/delete
   */
  keywordFilteringDeleteCreate = (
    data: AuthorizedSellerKeywordFilteringProtocolsDeleteKeywordRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<AuthorizedSellerKeywordFilteringProtocolsDeleteKeywordRequest, any>({
      path: `/authorized-seller/keyword-filtering/delete`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
